<div class="import-block">
    <div *ngIf="!aborted">
        <div class="mb-24">
            <h1>AI analyzing data...</h1>
            <span class="body-1">Wait for all processes to complete to see the result. it usually doesn't take long.</span>
        </div>

        <div class="mt-16">
            <div class="d-flex justify-content-between mb-8">
                <span class="body-2">Processing combinations</span>
                <span class="subtitle-2">{{shownCalcCombosPercent | number:'1.0-0'}}%</span>
            </div>
            <div class="bar">
                <div class="bar-line" [style.width]="shownCalcCombosPercent + '%'"></div>
            </div>
        </div>
        <div class="mt-16">
            <div class="d-flex justify-content-between mb-8">
                <span class="body-2">Processing graph</span>
                <span class="subtitle-2">{{shownGraphPercent | number:'1.0-0'}}%</span>
            </div>
            <div class="bar">
                <div class="bar-line" [style.width]="shownGraphPercent + '%'"></div>
            </div>
        </div>
        <div class="mt-16">
            <div class="d-flex justify-content-between mb-8">
                <span class="body-2">Evaluating events relevance</span>
                <span class="subtitle-2">{{shownDefaultViewCreationPercent | number:'1.0-0'}}%</span>
            </div>
            <div class="bar">
                <div class="bar-line" [style.width]="shownDefaultViewCreationPercent + '%'"></div>
            </div>
        </div>
        <div class="mt-24">
            <button mwlConfirmationPopover popoverTitle="Confirm abort" popoverMessage="Are you sure?" cancelText="No" confirmText="Yes" placement="top" (confirm)="onAbortClick()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-error':true}">Abort data analysis</button>
        </div>
    </div>

    <div *ngIf="aborted" class="aborted-state">
        <div class="bar-text">Processing aborted.</div>
        <div *ngIf="error" class="bar-text">{{error}}</div>
        <div>
            <button (click)="onReloadClick()" style="margin-top: 10px;" class="btn btn-gray">Restart</button>
            <a routerLink="/projects" style="margin-top: 10px; margin-left: 10px;" class="btn btn-white">Back to Projects</a>
        </div>
    </div>
</div>
